const $ = window.jQuery;
const formSelector = ".subscribe form";
const gaCategory = "Newsletter";

/**
 * Returns the position of the form: header, footer, interrupter
 */
function getGAlabel($el) {
  var label = "Interrupter";

  if ($el.parents("#menu-main").length) {
    label = "Header";
  } else if ($el.parents("footer.footer").length) {
    label = "Footer";
  }

  return label;
}

$(document).on("submit", formSelector, function (e) {
  e.preventDefault();

  var $t = $(this).addClass("is--loading is--loading--visible");
  const $notice = $t.find(".subscribe__notice");
  const $email = $t.find(".js--subscribe-email");
  const url = $t.attr("action");
  const data = $t.serialize();

  const showError = (err) => {
    console.error("fail", err);

    const errMsg = err.responseJSON
      ? `Error: ${err.responseJSON.message}`
      : "An error occurred. Please try again later.";

    $notice.addClass("error").html(errMsg).slideDown(300);

    $(window).trigger("ga.event", {
      category: gaCategory,
      action: "Error",
      label: getGAlabel($t),
    });
  };

  const resetForm = () => {
    $t.removeClass("is--loading--visible");

    setTimeout(() => $t.removeClass("is--loading"), 350); // matches the CSS opacity transition timing
  };

  console.log(data);

  $.ajax({ type: "POST", url, data })
    .done((data) => {
      console.log(data);
      if (data.success) {
        console.log("Success!", data);

        $notice
          .removeClass("error")
          .html(
            "Thank you, check your inbox (or junk folder) to confirm your subscription.",
          )
          .slideDown(300);

        $(e.target)
          .add(formSelector) // disable ALL subscribe forms when one is submitted, not just e.target
          .off()
          .find("input")
          .prop("disabled", "disabled");
        $email.val(data.body.replace(/"/g, ""));

        $(window).trigger("ga.event", {
          category: gaCategory,
          action: "Subscribe",
          label: getGAlabel($t),
        });
      } else {
        // Something went wrong, do something to notify the user.
        data.msg = data.msg || data.Message || "missing error message";
        var msg = data.msg.replace("0 - ", "");

        console.log("Success then fail?!", data);

        $notice.addClass("error").html(msg).slideDown(300);

        $(window).trigger("ga.event", {
          category: gaCategory,
          action: "Error",
          label: getGAlabel($t),
        });
      }
    })
    .fail(showError)
    .always(resetForm);
});
